import TransitApi from './base'

// Los cuatro reportes comparten forma de llamada: GET con filtros en el
// querystring y respuesta { data }. Se genera cada método desde un mapa para
// que agregar un reporte nuevo sea una línea.
const ENDPOINTS = {
  getFilters: 'filters',
  getCarteraPendiente: 'cartera-pendiente',
  getVencimientos: 'vencimientos',
  getClientes: 'clientes',
  getRechazos: 'rechazos',
}

const buildMethod = path =>
  async function fetchReport(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params || {})
      const result = await Api.get(`/reports/${path}?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  }

export default Object.keys(ENDPOINTS).reduce(
  (api, method) =>
    Object.assign(api, { [method]: buildMethod(ENDPOINTS[method]) }),
  {}
)
